import Splide from '@splidejs/splide';
// new Splide('.splide').mount;
const splides = document.getElementsByClassName('splide');
if(splides) {
  for (let i = 0; i < splides.length; i++) {
    new Splide(splides[i], {
      updateOnMove: true,
      type: 'loop',
      perPage: 1,
      padding: 0,
      gap: '48px',
      arrows: true,
      breakpoints: {
        1025: {
          gap: '0px',
        }
      }
    }).mount();
  }
}
// new Splide('.splide', {
//   mediaQuery: 'min',
//   breakpoints: {
//     1024: {
//       destroy: true,
//       type: 'loop',
//       perPage: '1',
//     }
//   }
// }).mount();